import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { getUserData } from "utils/userData";
import { getDashboardPath } from "services/api";
import { useSiteAssets } from "context/SiteAssetsContext";
import { SITE_ASSET_KEYS } from "utils/siteAssets";

const navItems = [
  { label: "Beranda", id: "beranda" },
  { label: "Layanan", id: "layanan" },
  { label: "Statistik", id: "statistik" },
  { label: "Pengaduan", id: "pengaduan" },
  { label: "Galeri", id: "galeri" },
  { label: "Akses Sistem", id: "akses" },
];

function scrollToSection(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

function LandingNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { userRole } = getUserData();
  const { getAssetUrl } = useSiteAssets();
  const logoUrl = getAssetUrl(SITE_ASSET_KEYS.LOGO_APLIKASI);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setMobileOpen(false);
    scrollToSection(id);
  };

  const navContent = (
    <>
      {navItems.map((item) => (
        <MDButton
          key={item.id}
          variant="text"
          color="inherit"
          onClick={() => handleNav(item.id)}
          sx={{ color: scrolled ? "dark.main" : "white", fontWeight: "regular", mx: 0.5 }}
        >
          {item.label}
        </MDButton>
      ))}
    </>
  );

  return (
    <>
      <AppBar
        position="fixed"
        elevation={scrolled ? 4 : 0}
        sx={{
          background: scrolled
            ? "rgba(255,255,255,0.95)"
            : "linear-gradient(180deg, rgba(0,0,0,0.35) 0%, transparent 100%)",
          backdropFilter: scrolled ? "blur(8px)" : "none",
          transition: "all 0.3s ease",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", py: 0.5 }}>
          <MDBox display="flex" alignItems="center" gap={1.5} component={Link} to="/" sx={{ textDecoration: "none" }}>
            <MDBox component="img" src={logoUrl} alt="Logo Rote Ndao" width="2.5rem" height="2.5rem" />
            <MDBox display={{ xs: "none", sm: "block" }}>
              <MDTypography variant="button" fontWeight="bold" color={scrolled ? "dark" : "white"} lineHeight={1.2}>
                DPMPTSP
              </MDTypography>
              <MDTypography variant="caption" color={scrolled ? "text" : "white"} display="block" lineHeight={1}>
                Kab. Rote Ndao
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDBox display={{ xs: "none", lg: "flex" }} alignItems="center">
            {navContent}
            {userRole ? (
              <MDButton
                variant="gradient"
                color="success"
                size="small"
                onClick={() => navigate(getDashboardPath(userRole))}
                sx={{ ml: 1 }}
              >
                Dashboard
              </MDButton>
            ) : (
              <MDButton
                variant="gradient"
                color="info"
                size="small"
                component={Link}
                to="/authentication/sign-in/cover"
                sx={{ ml: 1 }}
              >
                Login
              </MDButton>
            )}
          </MDBox>

          <IconButton
            color="inherit"
            edge="end"
            onClick={() => setMobileOpen(true)}
            sx={{ display: { lg: "none" }, color: scrolled ? "dark.main" : "white" }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
        <MDBox width="16rem" p={2}>
          <MDBox display="flex" justifyContent="flex-end" mb={1}>
            <IconButton onClick={() => setMobileOpen(false)}>
              <CloseIcon />
            </IconButton>
          </MDBox>
          <List>
            {navItems.map((item) => (
              <ListItem key={item.id} disablePadding>
                <ListItemButton onClick={() => handleNav(item.id)}>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
            <ListItem disablePadding>
              <ListItemButton
                component={userRole ? "button" : Link}
                to={userRole ? undefined : "/authentication/sign-in/cover"}
                onClick={userRole ? () => navigate(getDashboardPath(userRole)) : undefined}
              >
                <ListItemText primary={userRole ? "Dashboard" : "Login"} primaryTypographyProps={{ fontWeight: "bold" }} />
              </ListItemButton>
            </ListItem>
          </List>
        </MDBox>
      </Drawer>
    </>
  );
}

export default LandingNavbar;
